import React, { useState, useCallback, } from "react";
import { Outlet } from "react-router-dom";

const Content = (props) => {
    return (
      <>
        <div className={` ${props.isOpen ? "active-cont" : ""}  my-container`}>
          <nav
            className="navbar top-navbar navbar-light bg-light px-5"
            onClick={props.ToggleSidebar}
          >
            <a className="btn border-0" id="menu-btn">
              <i className="bi bi-list"></i>
            </a>
          </nav>
            <Outlet></Outlet>
        </div>
      </>
    );
}
export default Content